import { useEffect } from 'react'
import { useStoreActions } from '@mortgage-pos/ui/store'
import incense from '@mortgage-pos/ui/incense'
import { setCSRFToken } from '@mortgage-pos/utils'
import { borrowerPortalRequest } from '@mortgage-pos/ui/services/http'
import { isInIframe } from '../utils/iframeCheck'
import { MessageTypes } from '@mortgage-pos/types'

const useCheckAuthentication = () => {
  const { checkAuthentication } = useStoreActions(
    (store) => store.authentication
  )

  useEffect(() => {
    if (!isInIframe()) return
    // post message to BP to let them know that ALFIE has been initialized
    window.parent.postMessage(
      {
        name: MessageTypes.AlfieInitialized,
      },
      '*'
    )

    window.addEventListener('message', async (event) => {
      if (event.data.name === MessageTypes.BpAuth) {
        setCSRFToken(event.data.csrf)
        return checkAuthentication()
      }
    })
  }, [])

  const initializeBorrowerPortal = async () => {
    try {
      // don't run initialization if in iframe, BP will pass us the csrf token
      if (isInIframe()) return

      const response = await borrowerPortalRequest(`/initialize`, {}, {}, 'get')

      setCSRFToken(response.data.csrf)
    } catch (error) {
      incense(error)
        .details({
          name: 'InitializeBorrowerPortalError',
          message: 'Failed to initialize via BP API',
        })
        .error()
    }

    return checkAuthentication()
  }

  useEffect(() => {
    initializeBorrowerPortal()
  }, []) // eslint-disable-line

  return
}

export default useCheckAuthentication
